export default __webpack_public_path__ + "assets/46a73df31d32c31e3b0deaa5e4840ade.jpeg";